<template>
  <Layout2 :ratio="(selected ? '1fr 500px' : '1fr')" :style="{gap: 0}" id="prodsetting">
  <L2 slot="left" :style="{paddingRight: 0}" :bodyStyle="{ overflow: 'auto' }">
    <template slot="filter">
      <Select :defaultValue="storeType" @input="storeType=$event" :width="'200px'" :height="'40px'">
        <option :value="null">全部商店類別</option>
        <option :value="'tickets'">園區</option>
        <option :value="'restaurant'">餐廳</option>
      </Select>
      <Select v-if="area" :defaultValue="visible" @input="visible=$event" :width="'160px'" :height="'40px'">
        <option :value="null">全部</option>
        <option :value="true">顯示</option>
        <option :value="false">不顯示</option>
      </Select>
      <Select :defaultValue="type" @input="type=$event" :width="'160px'" :height="'40px'">
        <option :value="null">所有餐點</option>
        <option v-for="r in types" :key="r" :value="r">{{r}}</option>
      </Select>
      <Select :defaultValue="usage" @input="usage=$event" :width="'160px'" :height="'40px'">
        <option :value="null">餐點用途</option>
        <option v-for="r in usages" :key="r" :value="r">{{r}}</option>
      </Select>
      <SearchInput :style="{wdith: '360px', height: '40px'}" :width="'360px'" :defaultValue="searchText" @input="searchText=$event" :placeholder="'搜尋商品名稱、商品編號'"/>

      <sqr40016Vue :style="{marginLeft: 'auto', whiteSpace: 'nowrap'}" :icon="selected ? null : 'edit'" :text="collapse?'上下架' : '查看描述|說明'"
      :title="collapse ? '開啟上下架功能;[單一區域]可調整上下架;[所有區域]快速調整商品販售區域' : '關閉上下架功能;點擊商品查看說明'"
      :bg="collapse?'var(--color-pri)' : 'var(--color-checked)'"
      @click="() => {
        collapse=!collapse;
        edithtml=false;
        selected=collapse ? selected : null
      }"></sqr40016Vue>
      <Select :defaultValue="area" @input="area=$event" :width="'260px'" :height="'40px'">
        <option :value="null">所有區域</option>
        <option v-for="r in restaurants" :key="r" :value="r">{{r}}</option>
      </Select>
      <!-- <BtnSqr :bg="'var(--color-checked)'" :icon="'sort'" :text="'編輯排序'" :style="{marginLeft: 'auto'}"></BtnSqr> -->
    </template>
    <Table :rows="rows" :bodyStyle="{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }">
      <template slot="slot_head">
        <th :style="{width: '113px'}">商品圖</th>
        <th :style="{textAlign:'start', width: '140px'}" @click="sortById">商品編號</th>
        <th :style="[{textAlign:'start', width: 'inherit'}, collapse?{}:{maxWidth: '300px'}]" @click="sortByName">商品名稱</th>
        <th :style="{width: '160px'}">售價</th>
        <th :style="{width: '130px', textAlign: 'start'}">餐點類別</th>
        <th :style="{width: '130px', textAlign: 'start'}">餐點用途</th>
        <th :style="{minWidth: '130px', width: '130px', textAlign: 'center'}">組合</th>
        <th :style="{width: '60px'}">單位</th>
        <template v-if="!collapse">
        <th :style="{width: '120px', textAlign: 'center'}" v-if="area">顯示</th>
        <th :style="{width: '120px', textAlign: 'center'}" v-if="area">POS上線</th>
        <th :style="{width: '120px', textAlign: 'center'}" v-if="area">線上上線</th>
        <th :style="{width: '120px', textAlign: 'center'}" v-if="area">宅配</th>
        <template v-else>
          <th :style="{width: '120px', textAlign: 'center'}" v-for="(rest, r) in storeType?restaurantsInfos.filter(e => e.storeType===storeType).map(e => e.name):restaurants" :key="`rest-${r}`">{{rest}}</th>
        </template>
        </template>
        <th :style="{width: '80px'}" v-if="collapse">描述</th>
        <th :style="{width: '100px'}" v-if="collapse">顯示描述</th>
        <th :style="{width: '80px'}">編輯</th>
        <th :style="{width: '80px'}">刪除</th>
        <th :style="{width: '100px', minWidth: '40px'}"></th>
      </template>
      <tr slot-scope="{item: {name,name2,id,category, area:itemarea,image,type,unit,price,_id, pos, online, deliver, invisible, set, erpname, showContent, htmlContent}, index}"
      :style="{border:'none'}"
      :class="selected===_id?'selected':''">
        <td><div v-if="image" class="img" :style="{backgroundImage: `url(${VUE_APP_BASE_URL}${image})`}"></div></td>
        <td :style="{textAlign:'start'}">{{id}}</td>
        <td :style="{textAlign:'start',whiteSpace: collapse?'nowrap':'normal'}">{{name}}
          <span v-if="name2" :style="{color: '#CACACA'}"><br>{{name2}}</span>
          <span v-if="erpname" :style="{color: '#CACACA'}"><br>{{erpname}}</span></td>
        <td>{{price?`$${price}`:''}}</td>
        <td :style="{textAlign:'start',whiteSpace: 'nowrap'}">{{category}}</td>
        <td :style="{textAlign:'start',whiteSpace: 'nowrap'}">{{type}}</td>
        <td :style="{textAlign:'center',whiteSpace: 'nowrap'}"><div v-if="set?.length" :title="set.join(' ')" :style="{width:'100px',textAlign:'center', marginInline:'auto'}">{{set?.length || ''}}</div></td>
        <td>{{unit}}</td>
        <template v-if="!collapse">
        <td v-if="area"><button class="visible" :class="invisible.includes(area)?'':'actived'" @click.stop="update(index, _id, { invisible: invisible.includes(area)?invisible.filter(e => e!==area):[...invisible, area] })"></button></td>
        <td v-if="area"><button class="pos" :class="pos.includes(area)?'actived':''" @click.stop="update(index, _id, { pos: pos.includes(area)?pos.filter(e => e!==area):[...pos, area] })"></button></td>
        <td v-if="area"><button class="online" :class="online.includes(area)?'actived':''" @click.stop="update(index, _id, { online: online.includes(area)?online.filter(e => e!==area):[...online, area] })"></button></td>
        <td v-if="area"><button class="deliver" :class="deliver?'actived':''" @click.stop="update(index, _id, { deliver: !deliver })"></button></td>
        <template v-else>
          <td :style="{width: '120px', textAlign: 'center'}" v-for="(rest, r) in storeType?restaurantsInfos.filter(e => e.storeType===storeType).map(e => e.name):restaurants" :key="`rest-${r}`"
          ><div class="rest" :class="itemarea.includes(rest)?'actived':''"
          @click.stop="update(index, _id, { area: itemarea.includes(rest)?itemarea.filter(e => e!==rest):[...itemarea, rest ] })"></div></td>
        </template>
        </template>
        <td v-if="collapse">
          <div @click.stop="selecting(_id)" :class="htmlContent?'':'disabled'" class="contentView"></div>
        </td>
        <td v-if="collapse"><switchVue v-if="htmlContent" :defaultValue="showContent" @update="update(index, _id, { showContent: $event })"/></td>
        <td><EditBtn @click="$router.replace({ name: $route.name, query: { page: '單品管理', id: _id } })" :style="{marginInline: 'auto'}"></EditBtn></td>
        <td><DelBtn @click="deleteItem={_id, index, name}" :style="{marginInline: 'auto'}"></DelBtn></td>
        <td></td>
      </tr>
    </Table>
  </L2>
  <div :style="{borderLeft: '1px solid #CACACA', padding: '16px', display: 'grid', gridTemplateRows: '40px 1fr', height: '100%', gap: '15px', gridTemplateRows:'40px calc(100% - 55px)'}" v-if="selected">
    <div>
      <EditBtn :style="{marginLeft: 'auto'}" @click="htmlContent=item;edithtml=true;collapse=true" v-if="!edithtml"/>
      <Btns @cancel="edithtml=false" @save="updateHtml(htmlContent)" v-else :style="{justifyContent: 'flex-end'}"/>
    </div>
    <div v-html="item" v-if="!edithtml&&item" class="prodhtmlContent" :style="{overflowY: 'auto'}"></div>
    <div v-else-if="!edithtml" class="prodDetail">
      <img v-if="selectedDetail?.image" :src="`${VUE_APP_BASE_URL}${selectedDetail.image}`" alt="">
      <div class="name">{{selectedDetail.name}}</div>
      <div class="description" v-html="selectedDetail.description?.replaceAll('\n', '<br>')"></div>
      <div class="price">NT$ <span>{{selectedDetail.price}}</span> /{{selectedDetail.unit}}</div>
    </div>
    <quillEditor v-model="htmlContent" v-else
        ref="myQuillEditor" id="prodhtmlContent" :style="{height: 'calc(100vh - 267px)'}"
        :options="editorOption"/>

  </div>
  <comfirmVue :show="!!deleteItem"  v-if="!!deleteItem" :label="'確認刪除'" :text='`確定要刪除"${deleteItem.name}"嗎?`' @confirm="deleteOne(deleteItem._id, deleteItem.index)" @cancel="deleteItem=null"/>
  </Layout2>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import { mapState } from 'vuex'
import Btns from '../../../components/btn/btns.vue'
import DelBtn from '../../../components/btn/del.vue'
import EditBtn from '../../../components/btn/edit.vue'
import Table from '../../../components/tables/t2_drag.vue'
// import BtnSqr from '../../../components/btn/sqr40016.vue'
import SearchInput from '../../../components/input/search.vue'
import Select from '../../../components/select.vue'
import L2 from '../../../components/layout/LaTable.vue'
import Layout2 from '../../../components/layout/La1.vue'
import { getapi, deleteapi, postapi } from '../../../store/fetch'
import sqr40016Vue from '../../../components/btn/sqr40016.vue'
import switchVue from '../../../components/radio/switch.vue'
const { VUE_APP_BASE_URL } = process.env
export default {
  props: ['types'],
  components: {
    L2,
    Layout2,
    Select,
    SearchInput,
    switchVue,
    // BtnSqr,
    Table,
    EditBtn,
    DelBtn,
    Btns,
    quillEditor,
    sqr40016Vue
  },
  data () {
    return {
      visible: true,
      collapse: false,
      deleteItem: null,
      editorOption: {
        debug: 'htmlContent',
        placeholder: '商品說明'
      },
      storeType: null,
      edithtml: false,
      type: null,
      area: null,
      usage: null,
      searchText: null,
      rows: [],
      VUE_APP_BASE_URL,
      selected: null,
      item: null,
      htmlContent: null
    }
  },
  computed: {
    selectedDetail () {
      if (this.selected) {
        const index = this.rows.map(e => e._id).indexOf(this.selected)
        return this.rows[index]
      } else {
        return null
      }
    },
    ...mapState({
      restaurantsInfos: 'restaurantsInfos',
      restaurants: 'restaurants',
      usages: 'usages',
      defaultStore: 'defaultStore'
    })
  },
  async mounted () {
    this.area = this.defaultStore || null
    await this.getdata()
  },
  watch: {
    async selected () {
      if (this.selected) {
        const r = await getapi(`rest_product/single/content/${this.selected}`)
        this.item = r || ''
      } else {
        this.item = null
      }
    },
    async visible () { await this.getdata() },
    async searchText () { await this.getdata() },
    async usage () { await this.getdata() },
    async type () { await this.getdata() },
    async area () { await this.getdata() }
  },
  methods: {
    sortById () {
      console.log('sortById', this.rows.map(a => parseInt(a.id)))
      const rows = JSON.parse(JSON.stringify(this.rows))
      rows.sort((a, b) => parseInt(a.id) > parseInt(b.id) ? 1 : -1)
      console.log('sortById sort', this.rows.map(a => parseInt(a.id)))
      this.rows = rows
    },
    sortByName () {
      const rows = JSON.parse(JSON.stringify(this.rows))
      rows.sort((a, b) => a.name.localeCompare(b.name))
      this.rows = rows
    },
    selecting (_id) {
      if (this.collapse) {
        this.edithtml = false
        this.selected = this.selected === _id ? null : _id
      }
    },
    async updateHtml (htmlContent) {
      const box = document.createElement('div')
      box.innerHTML = htmlContent
      await Promise.all(Array.from(box.getElementsByTagName('img')).map(async (e, index) => {
        if (/data:image/.test(e.src)) {
          const filetype = e.src.slice(0, 40).split(',')[0].split(';')[0].split('/')[1]
          const file = await postapi('images/fromdata', { id: this.selected, index, image: e.src.split(',')[1], filetype: filetype === 'jpeg' ? 'jpg' : filetype, folder: 'setContent' })
          box.getElementsByTagName('img')[index].src = `.${file}`
        }
      })).then(async () => {
        const r = await postapi(`rest_product/single/${this.selected}`, { htmlContent: box.innerHTML })
        if (r) {
          this.item = await getapi(`rest_product/single/content/${this.selected}`)
          this.edithtml = false
        }
      })
    },
    async update (index, id, value) {
      console.log(value)
      const r = await postapi(`rest_product/single/${id}`, value)
      if (r) {
        this.rows.splice(index, 1, r)
      }
    },
    async deleteOne (id, index) {
      await deleteapi(`rest_product/single/${id}`)
      this.rows.splice(index, 1)
      this.deleteItem = null
    },
    async getdata () {
      const params = {}
      if (this.type) params.category = this.type
      if (this.area) {
        params.area = this.area
        if (this.visible !== null) params.visible = this.visible
      }
      if (this.usage) params.type = this.usage
      if (this.searchText) params.searchText = this.searchText
      const rows = await getapi('rest_product/single?' + new URLSearchParams(params))
      const sl = rows.map(e => e._id).find(e => e === this.selected)
      if (sl) {
        this.rows = rows
      } else {
        this.selected = null
        this.rows = rows
      }
    }
  }
}
</script>

<style lang="scss">
#prodsetting {
.La1_right {
  border-left: 1px solid #CACACA;
}
#prodhtmlContent {
  * {
    box-sizing: border-box;
  }
  strong {
    font-weight: bold;
  }
  em {
    font-style: italic;
  }
    .ql-size-small {
      font-size: 0.75em;
    }
    .ql-size-large {
      font-size: 1.5em;
    }
    .ql-size-huge {
      font-size: 2.5em;
    }
  .ql-font-serif {
    font-family: Georgia, Times New Roman, serif;
  }
  .ql-font-monospace {
    font-family: Monaco, Courier New, monospace;
  }
  .ql-container{
    // height: -webkit-fill-available;
  }
}
}
.prodhtmlContent, #prodhtmlContent {
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.1em;
  color: #5E5E5E;
  text-align: start;
  * {
    font-size: inherit;
    font-family: unset;
    font-weight: inherit;
  }
  img {
    max-width: 100%;
  }
  p {
  }
  h1 {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1em;
    color: #A06A28;
  }
  h2 {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.1em;
    color: #A06A28;
  }
}
</style>
<style lang="scss" scoped>
.prodhtmlContent {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
}

.contentView {
  width: 35px;
  height: 35px;
  mask-image: url(svg/btn/desc.svg);
  mask-size: contain;
  mask-position: center;
  mask-repeat: no-repeat;
  background-color: var(--color-pri);
  margin-inline: auto;
  &.disabled {
    background-color: #e5e5e5;
  }
}
.rest {
  width: 27px;
  height: 27px;
  margin: auto;
  &:hover {
    background-color: #CACACA;
    mask-image: url(svg/checkbox/checkmark.svg);
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
  }
  &.actived {
    background-color: var(--color-checked);
    mask-image: url(svg/checkbox/checkmark.svg);
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
  }
}
.prodDetail {
  height: -webkit-fill-available;
  background-color: var(--color-bar);
  font-size: 20px;
  line-height: 200%;
  color: var(--color-pri);
  display: flex;
  flex-direction: column;
  gap: 6px;
  img {
    width: 100%;
    max-width: 466px;
    width: auto;
    height: auto;
  }
  .name {
    font-size: 32px;
    font-weight: 700;
    margin-top: 20px;
  }
  .description {
    font-size: 20px;
    color: #5E5E5E;
    padding-inline: 15px;
  }
  .price {
    font-size: 18px;
    span {
      font-weight: 900;
      font-size: 30px;
      color: #FF8B8B;
      margin-inline: .5em;
    }
  }
}
.visible {
  width: 35px;
  height: 35px;
  mask-image: url(/svg/auth/visibility_off.svg);
  mask-position: center;
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: #B9B9B9;
  &.actived {
    mask-image: url(/svg/auth/visibility.svg);
    background-color: var(--color-checked);
  }
}
.pos {
  width: 35px;
  height: 35px;
  mask-image: url(/svg/status/posCircle.svg);
  mask-position: center;
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: #B9B9B9;
  &.actived {
    mask-image: url(/svg/status/posCheck.svg);
    background-color: #FF8B8B;
  }
}
.online {
  width: 40px;
  height: 30px;
  mask-image: url(/svg/status/cloudeE.svg);
  mask-position: center;
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: #B9B9B9;
  &.actived {
    mask-image: url(/svg/status/cloude.svg);
    background-color: var(--color-pri);
  }
}
.deliver {
  width: 36px;
  height: 30px;
  mask-image: url(/svg/status/trunk.svg);
  mask-position: center;
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: #B9B9B9;
  &.actived {
    mask-image: url(/svg/status/trunk.svg);
    background-color: var(--color-pri);
  }
}
.img {
  width: 73.33px;
  height: 50px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
